module.exports = __webpack_public_path__ + "img/logo-icon5.4c49620e.png";